import React from "react";
import { Link } from "react-router-dom";
import { FREE_ASSESSMENT_URL } from "../../constants/journey";
import { Footer, Header } from "../../components";
import { C, FONT, container } from "../../constants/mq";

// Resources hub. Points at what already exists (blog, course catalogue,
// free assessment) plus the questions we get asked most. Guides and
// downloads get added here as they are written.

const cards = [
  {
    title: "Course catalogue",
    body: "Every program we run, listed by year level and subject.",
    to: "/our-courses",
  },
  {
    title: "Free assessment",
    body: "A short online assessment that shows where your child is sitting before you enrol.",
    href: FREE_ASSESSMENT_URL,
  },
  {
    title: "Campuses",
    body: "Where we teach, with addresses and contact details for each location.",
    to: "/our-branches",
  },
];

const faqs = [
  {
    q: "Which year levels do you teach?",
    a: "Kindergarten to Year 12. Primary years cover WRMT along with OC and Selective test preparation, Year 7 to Year 10 cover English and Writing, Mathematics and Science, and Year 11 to 12 cover the HSC subjects.",
  },
  {
    q: "Can my child try a class first?",
    a: "Start with the free assessment. It shows the right level for your child, and our team will talk you through which class fits.",
  },
  {
    q: "Do you teach online as well as on campus?",
    a: "Yes. The material, teachers and assessments are the same whether your child attends a campus or joins online.",
  },
  {
    q: "How do I enrol?",
    a: "Use Enrol now in the top menu, or contact us and we will set it up with you.",
  },
];

const s = {
  hero: {
    background: `linear-gradient(112deg, ${C.bright} 0%, ${C.bright} 66%, #C2001A 66%, #C2001A 100%)`,
    color: "#fff",
    padding: "58px 0 54px",
    fontFamily: FONT,
  },
  container,
  eyebrow: {
    display: "inline-block", fontSize: 12.5, fontWeight: 600, letterSpacing: "1.2px",
    textTransform: "uppercase", color: "rgba(255,255,255,0.85)", margin: "0 0 14px",
  },
  h1: {
    fontSize: 40, fontWeight: 800, letterSpacing: "-0.5px", margin: 0, lineHeight: 1.18,
    color: "#fff", maxWidth: 680,
  },
  lead: { fontSize: 15.5, lineHeight: 1.65, color: "rgba(255,255,255,0.92)", margin: "14px 0 0", maxWidth: 620 },
  body: { padding: "56px 0 80px", background: "#fff", fontFamily: FONT },
  grid: {
    display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 24, marginBottom: 56,
  },
  card: { display: "block", padding: "22px 20px 24px" },
  cardTitle: { fontSize: 16, fontWeight: 700, color: C.ink, margin: "0 0 6px" },
  cardBody: { fontSize: 13.5, lineHeight: 1.6, color: C.body, margin: 0 },
  h2: { fontSize: 24, fontWeight: 700, color: C.ink, margin: "0 0 20px", letterSpacing: "-0.3px" },
  faq: { borderTop: `1px solid ${C.line}`, padding: "18px 0" },
  q: { fontSize: 15, fontWeight: 700, color: C.ink, margin: "0 0 6px" },
  a: { fontSize: 14, lineHeight: 1.7, color: C.body, margin: 0 },
  primary: { marginTop: 32 },
};

const Resources = () => (
  <div style={{ background: "#fff" }}>
    <Header />
    <main>
      <section style={s.hero}>
        <div style={s.container}>
          <span style={s.eyebrow}>Resources</span>
          <h1 style={s.h1}>Everything you need before you enrol</h1>
          <p style={s.lead}>
            Our course catalogue, the free assessment and answers to the
            questions parents ask us most.
          </p>
        </div>
      </section>

      <section style={s.body}>
        <div style={s.container}>
          <div style={s.grid}>
            {cards.map((c) =>
              c.href ? (
                <a
                  key={c.title}
                  className="mq-card"
                  style={s.card}
                  href={c.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h2 style={s.cardTitle}>{c.title}</h2>
                  <p style={s.cardBody}>{c.body}</p>
                </a>
              ) : (
                <Link key={c.title} className="mq-card" style={s.card} to={c.to}>
                  <h2 style={s.cardTitle}>{c.title}</h2>
                  <p style={s.cardBody}>{c.body}</p>
                </Link>
              )
            )}
          </div>

          <h2 style={s.h2}>Frequently asked questions</h2>
          {faqs.map((f) => (
            <div key={f.q} style={s.faq}>
              <p style={s.q}>{f.q}</p>
              <p style={s.a}>{f.a}</p>
            </div>
          ))}

          <Link className="mq-btn" style={s.primary} to="/contact-us">
            Still have a question? Contact us
          </Link>
        </div>
      </section>
    </main>
    <Footer />
  </div>
);

export default Resources;
